import React from 'react';
import PropTypes from 'prop-types';
import {
    StyledH3,
    StyledSubtitle
} from '../../../../../Title/styles/Title.styled';
import { StyledFareCard } from '../../style/FareSection.styled';
import { SubscriptionButton } from '../../../../../ButtonLink/components/SubscriptionLink';
import { SubscriptionFares } from '../../../../../../lib/enums';

export const FareCard = ({
    title,
    description,
    type,
    linkText,
    specificCss
}) => {
    return (
        <StyledFareCard $specificCss={specificCss}>
            <StyledH3>{title}</StyledH3>
            <StyledSubtitle>{description}</StyledSubtitle>
            <SubscriptionButton 
                text={linkText} 
                type={type}
            />
        </StyledFareCard>
    );
};

FareCard.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    type: PropTypes.number,
    linkText: PropTypes.string,
    specificCss: PropTypes.string
};
